module.exports = __webpack_public_path__ + "img/lr1-mc-rrr1.b5b800e5.gif";